import { Routes } from '@angular/router';
import { AuthGuard } from './auth/guard/auth.guard';
import { SigninOidcComponent } from './auth/signin-oidc/signin-oidc.component';
import { SignoutOidcComponent } from './auth/signout-oidc/signout-oidc.component';
import { AdminLayoutComponent } from './shared/components/layouts/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './shared/components/layouts/auth-layout/auth-layout.component';
import { AdministratorMetaregistraGuard } from './auth/guard/admin-metaregistra.guard';
export const rootRouterConfig: Routes = [
  {
    path: 'session',
    component: AuthLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./views/sessions/sessions.module').then(m => m.SessionsModule),
        data: { title: 'Login' }
      }
    ]
  },
  {
    path: 'signin-oidc',
    component: SigninOidcComponent,
  },
  {
    path: 'signout-oidc',
    component: SignoutOidcComponent,
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'pocetna',
        pathMatch: 'full'
      },
      {
        path: 'recnik-tipova',
        canActivate: [AuthGuard, AdministratorMetaregistraGuard],
        loadChildren: () => import('./features/recnik/tip/recnik-tipova.module').then(m => m.RecnikTipovaModule),
        data: { title: 'Rečnik tipova', breadcrumb: 'Rečnik tipova' }
      },
      {
        path: 'recnik-pojmova',
        canActivate: [AuthGuard, AdministratorMetaregistraGuard],
        loadChildren: () => import('./features/recnik/pojam/recnik-pojmova.module').then(m => m.RecnikPojmovaModule),
        data: { title: 'Rečnik pojmova', breadcrumb: 'Rečnik pojmova' }
      },
      {
        path: 'recnik-poruka',
        canActivate: [AuthGuard, AdministratorMetaregistraGuard],
        loadChildren: () => import('./features/recnik/poruka/recnik-poruka.module').then(m => m.RecnikPorukaModule),
        data: { title: 'Rečnik poruka', breadcrumb: 'Rečnik poruka' }
      },
      {
        path: 'administracija',
        canActivate: [AuthGuard, AdministratorMetaregistraGuard],
        loadChildren: () => import('./features/administracija/administracija.module').then(m => m.AdministracijaModule),
        data: { title: 'Administracija', breadcrumb: 'Administracija' }
      },
      {
        path: 'sluzbene-evidencije',
        canActivate: [AuthGuard],
        loadChildren: () => import('./features/sluzbena-evidencija/sluzbena-evidencija.module').then(m => m.SluzbenaEvidencijaModule),
        data: { title: 'Službena evidencija', breadcrumb: 'Službena evidencija' }
      },
      {
        path: 'administracija-sifarnika',
        canActivate: [AuthGuard],
        loadChildren: () => import('./features/sluzbena-evidencija/sluzbena-evidencija.module').then(m => m.SluzbenaEvidencijaModule),
        data: { title: 'Administracija šifarnika', breadcrumb: 'Administracija šifarnika' }
      },
      {
        path: 'pretraga',
        canActivate: [AuthGuard],
        loadChildren: () => import('./features/pretraga/pretraga.module').then(m => m.PretragaModule),
        data: { title: 'Pretraga', breadcrumb: 'Pretraga' }
      },
    ]
  },
  {
    path: '**',
    redirectTo: ''
  }
];

